import { COMMANDS, EVENTS } from "../constants";
import type { IMessage } from "../models";
import type { IFile } from "../../upload";
import type { IKendoJQuery } from "../../core";

export interface ICommandHandlerContext {
    getUserId: () => string;
    dataItem: (message: IKendoJQuery) => IMessage | null;
    fileDataItem: (message: IMessage, file: IKendoJQuery) => IFile | null;
    removeMessage: (message: IMessage) => boolean;
    pinMessage: (message: IMessage) => void;
    setReplyMessage: (message: IMessage, isOwnMessage: boolean) => void;
    setCurrentMessageReplyId: (id: string) => void;
    setupAriaAttributes: () => void;
    toggleDeleteVisibility: (isAuthor: boolean) => void;
    trigger: (event: string, args?: any) => void;
}

export class CommandHandler {
    private context: ICommandHandlerContext;

    constructor(context: ICommandHandlerContext) {
        this.context = context;
    }

    commandExecute(e: any): void {
        const message = this.context.dataItem(e.message);
        const file = this.context.fileDataItem(message!, e.file);
        const type = e.type;

        if (!file) {
            switch (type) {
                case COMMANDS.reply:
                    this.messageReply(message!);
                    break;
                case COMMANDS.copy:
                    this.messageCopy(message!);
                    break;
                case COMMANDS.pin:
                    this.messagePin(message!);
                    break;
                case COMMANDS.delete:
                    this.messageDelete(message!);
                    break;
            }
        } else {
            switch (type) {
                case COMMANDS.download:
                    this.context.trigger(EVENTS.download, { files: [file], message });
                    break;
            }
            this.context.trigger(EVENTS.fileMenuAction, { type, file, message });
        }
    }

    contextMenuExecute(e: any): void {
        this.commandExecute(e);
        const message = this.context.dataItem(e.message);
        const type = e.type;
        this.context.trigger(EVENTS.contextMenuAction, { type, message });
    }

    messageReply(message: IMessage): void {
        const isOwnMessage = message.authorId === this.context.getUserId();
        this.context.setCurrentMessageReplyId(message.id);
        this.context.setReplyMessage(message, isOwnMessage);
        this.context.setupAriaAttributes();
    }

    messageCopy(message: IMessage): void {
        if (navigator && navigator.clipboard) {
            navigator.clipboard.writeText(message.text);
        }
    }

    messagePin(message: IMessage): void {
        this.context.pinMessage(message);
    }

    messageDelete(message: IMessage): void {
        this.context.removeMessage(message);
    }

    messageContextMenuOpen(e: any): void {
        const message = this.context.dataItem(e.message);

        if (!message) {
            return;
        }

        const isAuthor = message.authorId === this.context.getUserId();
        this.context.toggleDeleteVisibility(isAuthor);
    }
}
